import { IsString, IsEmail, IsEnum, IsOptional, IsUUID, IsNotEmpty } from "class-validator";
import { CreateUserInterface, UpdateUserInterface } from "../../interface/users/modify-users.interface";
import { UserRole, UserStatus, UserPosition } from "../../interface/users/users-response.interface";

export class CreateUser implements CreateUserInterface {
  @IsUUID()
  id!: string;

  @IsEmail()
  email!: string;

  @IsEnum(UserRole)
  role!: UserRole;

  @IsString()
  @IsOptional()
  first_name?: string | null;

  @IsString()
  @IsOptional()
  last_name?: string | null;

  @IsString()
  @IsOptional()
  phone_number?: string | null;

  @IsEnum(UserStatus)
  status!: UserStatus;

  @IsEnum(UserPosition)
  @IsOptional()
  position?: UserPosition;

  @IsUUID()
  created_by_id!: string | null;

  @IsUUID()
  updated_by_id!: string | null;

  @IsUUID()
  @IsOptional()
  attachment_signature_id?: string | null;

  @IsUUID()
  @IsOptional()
  attachment_avatar_id?: string | null;
}

export class UpdateUser implements UpdateUserInterface {
  @IsUUID()
  @IsNotEmpty()
  id!: string;

  @IsOptional()
  @IsEmail()
  email?: string;

  @IsEnum(UserRole)
  role!: UserRole;

  @IsOptional()
  @IsString()
  first_name?: string | null;

  @IsOptional()
  @IsString()
  last_name?: string | null;

  @IsOptional()
  @IsString()
  phone_number?: string | null;

  @IsOptional()
  @IsEnum(UserStatus)
  status?: UserStatus;

  @IsOptional()
  @IsEnum(UserPosition)
  position?: UserPosition;

  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  attachment_signature_id?: string | null;

  @IsOptional()
  @IsUUID()
  attachment_avatar_id?: string | null;
}